import { ToastOptions, UNSTABLE_ToastQueue } from 'react-aria-components';

export class ToastQueue<T> extends UNSTABLE_ToastQueue<T> {
  // Pause the other toasts' timers when a new toast is added
  add(content: T, options?: ToastOptions): string {
    this.pauseAll();
    return super.add(content, options);
  }

  close(key: string): void {
    super.close(key);
    // Resume the timer for the next toast in the queue
    this.visibleToasts[0]?.timer?.resume();
  }

  resumeAll(): void {
    /**
     * Overwriting the default to only resume the first toast's timer
     * on blur or mouse leave
     */
    // for (let toast of this.visibleToasts) {
    //   if (toast.timer) {
    //     toast.timer.resume();
    //   }
    // }

    this.visibleToasts[0]?.timer?.resume();
  }
}
